import { EnumSchema, Executor, FromSchema, OptionalString } from '@40seas/entities/common';
import { UserRole } from '@40seas/entities/users';
import { TenantlessBaseEntity, WithTenantlessBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export enum AuthApplicationStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    SUSPENDED = 'suspended',
}

export const AuthApplicationSchema = WithTenantlessBaseEntitySchema(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    z.object({
        name: z
            .string({
                invalid_type_error: 'name should be a valid string',
                required_error: 'name is required',
                description: 'Human-readable name for the auth application',
            })
            .min(1)
            .max(100),
        description: z.string().max(500).optional(),
        clientId: z
            .string({
                required_error: 'clientId is required',
                description: 'Unique client identifier for the application',
            })
            .min(10),
        clientSecret: OptionalString(
            z.string().min(10, {
                message: 'Client secret must be at least 10 characters',
            }),
        ),
        status: EnumSchema(AuthApplicationStatus).optional(),
        roles: z.array(EnumSchema(UserRole)).optional(),
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
).strict();

export class AuthApplication extends FromSchema(AuthApplicationSchema) implements TenantlessBaseEntity {
    id: string;
    name: string;
    description?: string;
    clientId: string;
    clientSecret?: string;
    status?: AuthApplicationStatus;

    roles?: UserRole[];
    metadata?: { [key: string]: string };
    createdBy?: Executor;
    createdAt: Date;
    updatedAt: Date;
}
